import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BankingDetailsService } from 'src/app/shared/customer/banking-details/banking-details.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-enter-banking-details',
    templateUrl: './enter-banking-details.component.html',
    styleUrls: ['./enter-banking-details.component.css'],
    standalone: false
})
export class EnterBankingDetailsComponent implements OnInit {
  loading: boolean = true
  role: string
  serverErrorMessages: string
  serverSuccessMessage: string

  bankingDetails = new FormGroup({
    gstNumber: new FormControl('11AAAAA0000A1Z5',
    [Validators.required,
     Validators.minLength(15),
     Validators.maxLength(15)]),
    PAN: new FormControl('AAAAA0000A',
    [Validators.required,
     Validators.minLength(10),
     Validators.maxLength(10)]),
    currency: new FormControl('',
    [Validators.required]),
    bankName: new FormControl('',
    [Validators.required]),
    bankAccountNumber: new FormControl('',
    [Validators.required]),
    IFSC: new FormControl('',
    [Validators.required,
    Validators.minLength(11),
    Validators.maxLength(11)]),
    SWIFT: new FormControl('',
    [Validators.required,
     Validators.minLength(11),
     Validators.maxLength(11)])
  })
  constructor(private loginService: LoginService, private bankingDetailsService: BankingDetailsService, private router : Router) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  onSubmit(){
   //console.log(this.bankingDetails.value)
    this.bankingDetailsService.enterBankingDetails(this.bankingDetails.value).subscribe(
      res => {
       //console.log('success', res)
        alert('Your Bank Details will soon be Verified and we wiil get back to you')
        this.router.navigateByUrl('/home');
      },
      err => {
       //console.log('error from server', err)
        this.serverErrorMessages = err.error.message
      }
    )
  }


}
